/** BlueBob Design Direction — Bubble-Frame Arcade */

export const COLORS = {
  PRIMARY: '#FFD93D',       // Pineapple Yellow
  SECONDARY: '#E63946',     // Krusty Krab Red
  ACCENT: '#FF69B4',        // Jellyfish Pink
  OCEAN: '#1A8F9E',         // Ocean Teal
  DEEP: '#0B3D54',          // Deep Ocean
  SAND: '#F4E8C1',          // Sandy Beige
  CORAL: '#FF6B35',         // Coral Orange
  FOAM: '#E8F4F8',          // Sea Foam
  TEXT: '#1A1A2E',          // Ink Navy
  TEXT_LIGHT: '#F4E8C1',    // Sandy Light
  BUBBLE_FILL: 'rgba(26, 143, 158, 0.15)',
  BUBBLE_BORDER: 'rgba(255, 255, 255, 0.6)',
} as const

export const FONTS = {
  DISPLAY: 'Luckiest Guy',
  BODY: 'Baloo 2',
  DISPLAY_SIZE_TITLE: 48,
  DISPLAY_SIZE_HEADER: 32,
  DISPLAY_SIZE_BUTTON: 24,
  BODY_SIZE_NORMAL: 18,
  BODY_SIZE_SMALL: 14,
} as const

export const BUBBLE = {
  CORNER_RADIUS: 40,
  MIN_CORNER_RADIUS: 20,
  PANEL_OPACITY: 0.85,
  ENTER_DURATION_MS: 400,
  EXIT_DURATION_MS: 250,
  IDLE_BOB_PX: 3,
  IDLE_BOB_PERIOD_MS: 4000,
  BUTTON_PRESS_SCALE: 0.9,
  HOVER_WOBBLE_DEG: 2,
} as const
